import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Map } from 'immutable';
import classNames from 'classnames';
import { Label } from 'synfrastructure';

class ReduxFormTextInputWithAction extends Component {
  static propTypes = {
    action: PropTypes.func.isRequired,
    className: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    promoCode: PropTypes.instanceOf(Map),
  };

  static defaultProps = {
    className: null,
    label: null,
  };

  handleSubmit = value => {
    const { action } = this.props;
    if (value) {
      action(value);
    }
  };

  handleKeyDown = e => {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  };

  handleKeyUp = e => {
    const { input } = this.props;

    if (e.keyCode === 13) {
      this.handleSubmit(e.currentTarget.value);
    } else {
      input.onChange(e);
    }
  };

  handleChange = e => this.props.input.onChange(e);

  render() {
    const { label, className, promoCode, input } = this.props;

    const textDisabled = promoCode.get('loading') || !!promoCode.getIn(['data', 'valid']);
    const buttonDisabled = !input.value.trim() || textDisabled;
    const error = !!promoCode.get('error') && 'Promo Code is invalid or expired';

    const scaffoldClasses = {
      'input-scaffold': true,
      [className]: className,
    };

    const labelClasses = {
      input: true,
      'input--disabled': textDisabled,
    };

    return (
      <div className={classNames(scaffoldClasses)}>
        <Label className={classNames(labelClasses)}>
          {label ? <span className="input-label">{label}</span> : null}
          <div className="promo-button--wrapper">
            <input
              className="promo-button--text"
              disabled={textDisabled}
              type="text"
              placeholder="Promo Code"
              onKeyDown={this.handleKeyDown}
              onKeyUp={this.handleKeyUp}
              onChange={this.handleChange}
              value={input.value}
            />
            <button
              type="button"
              className={classNames({
                button: true,
                'apply-button': true,
                'promo-applied': !!promoCode.getIn(['data', 'valid']),
              })}
              disabled={buttonDisabled}
              onClick={() => {
                this.handleSubmit(input.value);
              }}
            >
              {!!promoCode.getIn(['data', 'valid']) ? 'Applied' : 'Apply'}
            </button>
          </div>
        </Label>
        {error ? <div className="input-validation">{error}</div> : null}
      </div>
    );
  }
}

export default ReduxFormTextInputWithAction;



// WEBPACK FOOTER //
// ./src/common/forms/ReduxFormPromoCodeInput.js